import { LereToursPricingSuggestionsParams } from '~/components/LERE/types';

export const lereToursPricingSuggestionsQueryKeys = {
  all: ['lere', 'tours-pricing-suggestions'] as const,
  lists: () => [...lereToursPricingSuggestionsQueryKeys.all, 'list'] as const,
  list: (params: LereToursPricingSuggestionsParams) =>
    [...lereToursPricingSuggestionsQueryKeys.lists(), params] as const,
};
